import {ListGroupItem} from "reactstrap";
import classes from "../ArticleList.module.css"
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faThumbsDown, faThumbsUp, faUserCircle} from "@fortawesome/free-solid-svg-icons";
import {articleContentLangWithLimit, timeStampToPostString} from "../../../Utils/converter";
import React from "react";
import {MDBBadge} from "mdbreact";

import common from '../../../Utils/common.module.css'


const Article = (props) => {
    return (
        <ListGroupItem className={classes.ListGroupItem}>
            <Link to={{
                pathname: '/article/' + props.data.id,
                state: {article: props.data}
            }}>

                <div className={classes.UserIcon}>
                    {/*<FontAwesomeIcon icon={faUserCircle}/> User*/}
                    <MDBBadge color="link" className={common.AdminBadge}>Tmingler Admin</MDBBadge>
                </div>
                <div className={classes.Date}>
                    {timeStampToPostString(props.data.createDate.seconds)}
                </div>

                <div className={classes.PostTitle}>
                    {articleContentLangWithLimit(props.data.title)}
                </div>


                {/*<div className={classes.PostAction}>*/}
                {/*    {props.data.numberOfLike}*/}
                {/*    <FontAwesomeIcon icon={faThumbsUp} className={classes.ThumbsUp}/>*/}
                {/*    <FontAwesomeIcon icon={faThumbsDown} className={classes.ThumbsDown}/>*/}
                {/*    {props.data.numberOfDislike}*/}
                {/*</div>*/}
            </Link>
        </ListGroupItem>
    )
}
export default Article